import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EntityTypes } from '@guryou/core';
const useEntityTypes = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    showAll: false,
    showVideos: true,
    showWorkouts: false,
    showMemberships: false,
    showBundles: false,
    showPlans: false
  };
  const [values, setValues] = useState(null);
  const {
    t
  } = useTranslation();
  if (!values) {
    const val = [];
    options.showAll && val.push({
      value: 'all',
      label: t('GENERAL.all')
    });
    val.push({
      value: EntityTypes.service,
      label: t('GENERAL.services')
    });
    val.push({
      value: EntityTypes.course,
      label: t('GENERAL.courses')
    });
    val.push({
      value: EntityTypes.event,
      label: t('GENERAL.events')
    });
    options.showVideos && val.push({
      value: EntityTypes.video,
      label: t('GENERAL.videos')
    });
    // options.showWorkouts && val.push({ value: EntityTypes.workout, label: t('GENERAL.workout') });
    options.showPlans && val.push({
      value: EntityTypes.plan,
      label: t('WORKOUTPLANS.titlePlural')
    });
    options.showMemberships && val.push({
      value: EntityTypes.membership,
      label: t('GENERAL.membership')
    });
    options.showBundles && val.push({
      value: EntityTypes.bundle,
      label: t('GENERAL.bundle')
    });
    setValues(val);
  }
  return values;
};
export { useEntityTypes };